import newagencymodaltpl from './newAgencyModal.tpl.html';

export class NewAgencyModal {
  constructor(companiesService, $scope) {
    Object.assign(this, {
      companiesService,
      $scope,
    });
  }

  $onInit() {
    this.agency = {};
  }

  closeModal() {
    this.onModalClose({});
  }

  createCompany() {
    if (this.newAgencyForm.$valid) {
      this.onModalAccept({
        agency: this.agency,
      });
    } else {
      this.showErrors = true;
    }
  }
}

NewAgencyModal.$inject = ['companiesService', '$scope'];

export const newAgencyModal = {
  template: newagencymodaltpl,
  controller: NewAgencyModal,
  bindings: {
    onModalClose: '&',
    onModalAccept: '&',
  },
};
